export class Refund {

    public id: string = "0";
    public product_id: string;
    public date: Date;
    public percent: number;

    constructor() {}
}


export class OrderRefund {

    public order_id: string;
    public account: string;
    public agency: string;
    public bank: string;
    public bankName: string;
    public dateRequest: Date;
    public dateRefund: Date;
    public discount: number;
    public total: number;
    public creditcard: boolean;

    constructor() {}
}





